export default __webpack_public_path__ + "static/media/Orange ribbon.6420956a.svg";